module.exports = __webpack_public_path__ + "static/media/icon_bluilding_mixedblue.1b91b697.svg";